import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import { AuthenticateStore , ServerStore } from '@seedlang/stores';
import { AuthenticateStatus } from 'components/authenticate/authenticate_status';
import FormWrapper from 'components/authenticate/form_wrapper';
import Text from 'components/text';
import Button from 'components/button/button';
import { isValidEmail } from '@seedlang/utils';
import { Theme } from '@seedlang/constants';
import Spinner from 'components/spinner';
import { AppUI } from '@seedlang/state';

const submitLabel = (linkSent, cooldownSeconds) => {
  if (cooldownSeconds > 0) {
    return `Resend Link (in ${cooldownSeconds} ${cooldownSeconds === 1 ? 'second' : 'seconds'})`;
  }
  return linkSent ? 'Resend Link' : 'Reset Password';
};

export const AuthenticateForgotPassword = ({
  accentColor,
  cooldownSeconds,
  disabled,
  email,
  errorMessage,
  linkSent,
  onChangeEmail,
  onSubmit,
  siteIsSeedlang,
  submitting,
  successMessage,
}) => (
  <FormWrapper
    padding='20px'
  >
    <form onSubmit={onSubmit} autoComplete='off'>
      <Text
        center
        heading='3'
        margin='0 0 10px 0'
        color='#333'
      >
        Forgot Your Password?
      </Text>
      <AuthenticateStatus
        errorMessage={errorMessage}
        successMessage={successMessage}
      />
      <div>
        <label style={{color: '#333'}} htmlFor='user_email'>Email</label>
        <input
          required
          type='email'
          value={email}
          onChange={el => onChangeEmail(el.target.value)}
        />
      </div>
      {
        submitting &&
          <Spinner
            background={siteIsSeedlang ? Theme.blue : accentColor}
          />
      }
      {
        !submitting &&
          <Button
            margin='10px 0 0 0'
            onClick={onSubmit}
            disabled={disabled}
            height='50px'
            width='100%'
            borderRadius='50px'
            background={siteIsSeedlang ? Theme.blue : accentColor}
            backgroundOnHover={siteIsSeedlang ? Theme.blue : accentColor}
            color={disabled ? '#e4e4e4' : '#FFF'}
          >
            {submitLabel(linkSent, cooldownSeconds)}
          </Button>
      }
    </form>
  </FormWrapper>
);

@observer
class AuthenticateForgotPasswordWrapper extends React.Component {
  @observable email = '';
  @observable submitting = false;
  @observable linkSent = false;
  @observable cooldownSeconds = 0;

  @computed get disabled() {
    return !isValidEmail(this.email) || this.cooldownSeconds > 0;
  }

  componentDidMount() {
    ServerStore.clearMessages();
  }

  componentWillUnmount() {
    clearInterval(this.cooldownInterval);
  }

  startCooldown(seconds) {
    clearInterval(this.cooldownInterval);
    this.cooldownSeconds = seconds;
    this.cooldownInterval = setInterval(this.tickCooldown, 1000);
  }

  tickCooldown = () => {
    this.cooldownSeconds -= 1;
    if (this.cooldownSeconds <= 0) {
      clearInterval(this.cooldownInterval);
      ServerStore.clearMessages();
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (!this.disabled) {
      this.submitting = true;
      AuthenticateStore.sendResetPasswordInstructions({data: {
        email: this.email,
      }}, this.afterSubmit);
    }
  }
  afterSubmit = (resp) => {
    this.submitting = false;
    if (resp?.cooldownSeconds > 0) {
      this.linkSent = true;
      this.startCooldown(resp.cooldownSeconds);
    }
  }

  render() {
    return (
      <AuthenticateForgotPassword
        accentColor={AppUI.site.accentColor}
        cooldownSeconds={this.cooldownSeconds}
        disabled={this.disabled}
        email={this.email}
        errorMessage={ServerStore.errorMessage}
        linkSent={this.linkSent}
        onChangeEmail={email => this.email = email}
        onSubmit={this.onSubmit}
        siteIsSeedlang={AppUI.siteIsSeedlang}
        submitting={this.submitting}
        successMessage={ServerStore.successMessage}
      />
    );
  }
}

export default AuthenticateForgotPasswordWrapper;
